import { action, createRequestTypes } from '../base';

export const quickUpdateActionTypes = {
  QUICK_UPDATE_ENTITY_WISE: createRequestTypes('QUICK_UPDATE_ENTITY_WISE'),
};

class QuickUpdateActions {
  // Quick Update
  quickUpdateEntityWise = (payload, callback, rollback) => action(quickUpdateActionTypes.QUICK_UPDATE_ENTITY_WISE.REQUEST, {
    payload, callback, rollback,
  })

  quickUpdateEntityWiseLoading = (quickUpdateLoading) => action(quickUpdateActionTypes.QUICK_UPDATE_ENTITY_WISE.LOADING, {
    quickUpdateLoading,
  })
}

export default new QuickUpdateActions();
